import { globalEventBus } from '@fiverr-private/futile';
import {
    EVENT_NAME,
    START_SESSION_RECORDING_EVENT,
    STOP_SESSION_RECORDING_EVENT
} from '../../helpers/constants';
import logger from '../../../logger/emitter';
import isDev from '../../../helpers/isDev';
import Mixpanel from './Mixpanel';
import getInstanceEnrichment from './instanceEnrichment';

/**
 * Logs the tracked event, used in development mode.
 * To be used in development mode.
 * @param {string} eventName The event's name.
 * @param {Object} eventProperties The event's properties.
 */
const logInfo = (eventName, eventProperties = {}) => {
    logger.info('Mixpanel event:', {
        eventName,
        eventProperties
    });
};

/**
 * Listens to mixpanel events emitted on the global event bus.
 * @param {Object} args Configuration.
 * @param  {String} [args.userId] The current user's ID.
 * @param  {String} [args.userGuid] The current user's guid.
 * @param  {Object} [args.baseProperties] A base set of properties to add to all events.
 * @param  {String} args.token Mixpanel token.
 * @param  {Number} [args.recordSessionPercent] Mixpanel record session percentage.
 * @param {Boolean} [configuration.recordHeatmapData] Mixpanel Heatmap data collection,
 * @return {Boolean} Whether the listener was registered succesfully.
 * @see getInstanceEnrichment - Enriches each outgoing event with global scope mixpanel enrichment attributes.
 */
const mixpanelListener = (args = {}) => {
    const mixpanel = Mixpanel({
        ...args,
        baseProperties: { ...getInstanceEnrichment(), ...args.baseProperties }
    });
    const { mode } = args;
    const dev = isDev(mode);

    const eventHandlers = {
        [EVENT_NAME]: dev ? logInfo : mixpanel.track,
        [START_SESSION_RECORDING_EVENT]: dev
            ? () => logInfo(START_SESSION_RECORDING_EVENT)
            : mixpanel.startSessionRecording,
        [STOP_SESSION_RECORDING_EVENT]: dev
            ? () => logInfo(STOP_SESSION_RECORDING_EVENT)
            : mixpanel.stopSessionRecording
    };

    Object.entries(eventHandlers).forEach(([eventName, handler]) => {
        if (!globalEventBus.has(eventName)) {
            globalEventBus.on(eventName, handler);
        }
    });
};

export default mixpanelListener;
